module.exports = __webpack_public_path__ + "e487499ea7187aef9666995e669d12fc.pdf";